import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Table } from "../../components";
import { useAppContext } from "../../context/state";
import { useRequest } from "../../utils";
//locall

const ForumCategories = (props) => {
  const [
    get_forum_categories_error,
    get_forum_categories_loading,
    get_forum_categories_data,
    get_forum_categories_function,
  ] = useRequest({
    method: "post",
    url: "/get_forum_categories",
  });
  let history = useHistory();

  // console.log(get_forum_categories_data);
  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      {/* <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                جدول های اطلاعاتی
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جدول اطلاعات</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div class="content-body">
        {/* <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div> */}
        <button
          style={{ margin: "15px" }}
          type="button"
          class="btn btn-success "
          onClick={() => {
            history.push("/dashboard/addForumCategory");
          }}
        >
          افزودن دسته بندی جدید
        </button>
        {get_forum_categories_data ? (
          <Table
            Thead={() => (
              <tr>
                <th className="table--title">نام دسته بندی</th>
                <th className="table--title">عملیات</th>
              </tr>
            )}
            Tbody={() =>
              get_forum_categories_data.data.map((item) => (
                <tr>
                  <td>{item.title}</td>
                  <td>
                    {/* <Link to={"/dashboard/commentDetails/" + item._id}>
                      <button
                        type="button"
                        class="btn btn-primary round mr-1 mb-1 btn-sm"
                      >
                        نمایش
                      </button>
                    </Link> */}
                  </td>
                </tr>
              ))
            }
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { ForumCategories };
